import React from 'react';
import { FormattedMessage } from 'react-intl';
import { RadioGroup, Brand, BrandName } from '@printdeal/ui-library';
// @ts-expect-error
import { paymentMethodIds } from '../../../../../../helpers/payments/paymentMethods';
// @ts-expect-error
import { messages } from '../../../../translations/orders';

interface PaymentMethodOptionProps {
  paymentMethod: { id: string };
  selectedPaymentMethod: string;
  setSelectedPaymentMethod: (selectedPaymentMethod: string) => void;
}

const PaymentMethodOption = ({
  paymentMethod,
  selectedPaymentMethod,
  setSelectedPaymentMethod,
}: PaymentMethodOptionProps) => (
  <RadioGroup.Field
    id={`${paymentMethod.id}_payment`}
    value={paymentMethod.id}
    onChange={() => setSelectedPaymentMethod(paymentMethod.id)}
    checked={paymentMethod.id === selectedPaymentMethod}
    label={<FormattedMessage id={messages[paymentMethod.id].id} />}
    data-cy={paymentMethod.id}
    description={
      (
        <>
          {
            paymentMethod.id === paymentMethodIds.creditCard && (
              <>
                <Brand brand="mastercard" className="pd-inline-block pd-h-12" />
                <Brand brand="visa" className="pd-ml-2 pd-inline-block pd-h-12" />
              </>
            )
          }
          {(paymentMethod.id === paymentMethodIds.bcmc
            || paymentMethod.id === paymentMethodIds.bcmc_mobile) && (
              <Brand brand="bancontactmrcash" className="pd-inline-block pd-h-12" />
          )}
          {(
            paymentMethod.id !== paymentMethodIds.bcmc
            && paymentMethod.id !== paymentMethodIds.bcmc_mobile
            && paymentMethod.id !== paymentMethodIds.creditCard
            && paymentMethod.id !== paymentMethodIds.onAccount
          ) && (
          <Brand brand={paymentMethod.id as BrandName} className="pd-inline-block pd-h-12" />
          )}
        </>
      )
    }
  />
);

export default PaymentMethodOption;
